
const setPlaceholder = (text, $element) =>
{
    $element.attr('placeholder', text);
};


$(() =>
{
    $('[data-placeholder-value-from]').each((idx, elm) =>
    {
        const $self = $(elm);
        const radioGroupName = $self.data('placeholder-value-from');

        const radiosGroup = $(`input[type="radio"][name="${radioGroupName}"]`);

        radiosGroup.each((idex, elem) =>
        {
            const $child = $(elem);
            let text = $child.parent().text();

            if ($child.parent().data('placeholder'))
            {
                text = $child.parent().data('placeholder')
            }

            $child.on('click', () =>
            {
                if ($child.is(':checked'))
                {
                    setPlaceholder(text, $self);
                }
            });
        });

        // @TODO initial state
    })
});



// WEBPACK FOOTER //
// ./resources/assets/js/components/form/placeholder-value-from.js